import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterModule, Routes } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { GenericInputModule, GenericSelectInputModule } from '@sla-ng/ui-material';
import { NgChartsModule } from 'ng2-charts';
import { BreakEvenListModule } from '../../../components/break-even-list/break-even-list.module';
import { CostUnitCostPage } from './cost-unit-cost-page';

export * from './cost-unit-cost-page';

const routes: Routes = [
    {
        path: '',
        component: CostUnitCostPage,
    },
];


@NgModule({
    declarations: [ CostUnitCostPage ],
    imports: [
        NgChartsModule,
        MatTableModule,
        CommonModule,
        RouterModule.forChild(routes),
        GenericInputModule,
        GenericSelectInputModule,
        MatDividerModule,
        TranslateModule,
        MatProgressBarModule,
        MatTabsModule,
        BreakEvenListModule,
    ],
})
export class CostUnitCostPageModule {
}
